import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const DisclaimerPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-blue-500 to-green-500 rounded-lg">
              <i className="ri-heart-pulse-line text-white text-xl"></i>
            </div>
            <span className="text-xl font-bold text-gray-900">Liver Health Check</span>
          </button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8 notranslate" translate="no">免責事項</h1>

          <div className="bg-white rounded-2xl p-8 shadow-lg space-y-8 notranslate" translate="no">
            <div className="p-6 bg-yellow-50 border-l-4 border-yellow-500 rounded-lg">
              <p className="text-sm text-gray-700 leading-relaxed font-bold">
                本サービスは医療行為・診断・治療を行うものではありません。健康情報の提供を目的としています。
              </p>
            </div>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">サービスの性質</h2>
              <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>本サービス「Liver Health Check」は、以下の性質を有します。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>医療行為、診断、治療を行うものではありません</li>
                  <li>医療判断の代替となるものではありません</li>
                  <li>健康情報の提供を目的としています</li>
                  <li>日本肝臓学会および日本消化器病学会のガイドライン等に基づいた、国際的に利用されている指標を用いた参考情報を提供します</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">結果の解釈について</h2>
              <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>本サービスで表示される結果について、以下の点にご注意ください。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>結果は参考情報であり、診断ではありません</li>
                  <li>結果の解釈や対応については、必ず医師にご相談ください</li>
                  <li>体調不良や不安がある場合は、速やかに医療機関を受診してください</li>
                  <li>本サービスの結果のみに基づいて医療判断を行わないでください</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">正確性について</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                当事業者は、本サービスの内容について正確性を期すよう努めておりますが、その正確性、完全性、有用性について保証するものではありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">損害の免責</h2>
              <div className="space-y-3 text-sm text-gray-700 leading-relaxed">
                <p>当事業者は、以下の事項について一切の責任を負いません。</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>本サービスの利用により生じた損害</li>
                  <li>本サービスの結果に基づく判断により生じた損害</li>
                  <li>本サービスの中断、停止、終了により生じた損害</li>
                  <li>入力データの誤りにより生じた損害</li>
                  <li>その他、本サービスに関連して生じた損害</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">サービスの変更・中断・終了</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                当事業者は、事前の通知なく本サービスの内容を変更、中断、終了することができるものとします。これにより利用者に生じた損害について、当事業者は一切の責任を負いません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">外部リンク</h2>
              <p className="text-sm text-gray-700 leading-relaxed">
                本サービスから外部サイトへのリンクが含まれる場合がありますが、当事業者は外部サイトの内容について一切の責任を負いません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-4">医療機関への相談</h2>
              <div className="p-6 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <strong>重要：</strong>本サービスは医療の代替となるものではありません。
                  体調不良や不安がある場合、または本サービスの結果について詳しく知りたい場合は、
                  必ず医師・医療機関にご相談ください。
                </p>
              </div>
            </section>

            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">制定日：2026年1月1日</p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
            >
              ← トップページへ戻る
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default DisclaimerPage;
